import { forwardRef } from 'react';
import { NextgenImage } from '../NextgenImage/NextgenImage';
import { type LoaderProps } from './types/propsType';
import styles from './Loader.module.scss';

const Loader = forwardRef<HTMLDivElement, LoaderProps>(
  ({ spinner, loaderContent, loaderHeading, loaderImage }: LoaderProps, ref) => (
    <div className={styles['loader-container']} ref={ref}>
      {loaderImage ? (
        <div className={styles['loader-image']}>
          <NextgenImage src={loaderImage} alt={'Loading...'} />
        </div>
      ) : null}
      <div className={styles['loader-heading']}>{loaderHeading}</div>
      <div className={styles['loader-content']}>{loaderContent}</div>
      <div className={styles['loader-spinner']}>
        <NextgenImage src={spinner} alt="loading..." />
      </div>
    </div>
  ),
);
Loader.displayName = 'Loader';
export default Loader;
